module.exports = __webpack_public_path__ + "static/media/logo.0a5d6349.svg";